import { createRouter, createRoute, createRootRoute } from "@tanstack/react-router";
import { Home } from "./pages/Home";
import { ViewerPage } from "./pages/Viewer";
import { ProjectPage } from "./pages/Project";
import { ReadinessPage } from "./pages/Readiness";
import { NormalizePage } from "./pages/Normalize";
import { MepPage } from "./pages/Mep";
import { CodesMonitorPage } from "./pages/CodesMonitor";

const rootRoute = createRootRoute();

const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: Home,
});

const viewerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/viewer",
  component: ViewerPage,
});

const modelViewerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/models/$modelId/viewer",
  component: ViewerPage,
});

const projectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/projects/$projectId",
  component: ProjectPage,
});

const readinessRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/models/$modelId/readiness",
  component: ReadinessPage,
});

const normalizeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/models/$modelId/normalize",
  component: NormalizePage,
});

const mepRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/models/$modelId/mep",
  component: MepPage,
});

const codesMonitorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/codes-monitor",
  component: CodesMonitorPage,
});

const routeTree = rootRoute.addChildren([
  homeRoute,
  viewerRoute,
  modelViewerRoute,
  projectRoute,
  readinessRoute,
  normalizeRoute,
  mepRoute,
  codesMonitorRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
